import { createBrowserRouter } from 'react-router-dom';
import App from '@/App';

import Main from '@/views/Main/Main';
import Home from '@/views/Home/Home';
import Device from '@/views/Device/Device/Device';
import DeviceDetail from '@/views/Device/Device/Detail';
import DeviceCreate from '@/views/Device/Device/Create';
import DeviceEdit from '@/views/Device/Device/Edit';
import NotFound from '@/views/404/404';
import User from '@/views/Manage/User/List';
import Role from '@/views/Manage/Role/List';
import SetRolePermission from '@/views/Manage/Role/SetPermission';
import DeviceType from '@/views/Device/DeviceType/List';
import CreateDeviceType from '@/views/Device/DeviceType/Create';
import DeviceTypeDetail from '@/views/Device/DeviceType/Detail';
import DeviceTypeEdit from '@/views/Device/DeviceType/Edit';
import Company from '@/views/Company/Company/Company';
import CompanyDetail from '@/views/Company/Company/Detail';
import CompanyEdit from '@/views/Company/Company/Edit';
import CompanyCreate from '@/views/Company/Company/Create';
import CompanyMenu from '@/views/Company/CompanyMenu/CompanyMenu';
import PlatformMenu from '@/views/Company/PlatformMenu/PlatformMenu';

const router = createBrowserRouter([
  {
    path: '/',
    Component: App,
  },
  {
    breadcrumb: '首页',
    path: '/main',
    Component: Main,
    children: [
      {
        index: true,
        Component: Home,
      },
      {
        breadcrumb: '首页',
        path: '/main/home',
        Component: Home,
        state: { title: '首页' }
      },
      {
        breadcrumb: '设备管理',
        path: '/main/deviceList',
        Component: Device,
        state: { title: '设备管理' }
      },
      {
        breadcrumb: '设备详情',
        path: '/main/device/detail',
        Component: DeviceDetail,
        state: { title: '设备详情' }
      },
      {
        breadcrumb: '添加设备',
        path: '/main/device/create',
        Component: DeviceCreate,
        state: { title: '添加设备' }
      },
      {
        breadcrumb: '编辑设备',
        path: '/main/device/edit',
        Component: DeviceEdit,
        state: { title: '编辑设备' }
      },
      {
        breadcrumb: '设备型号',
        path: '/main/deviceType',
        Component: DeviceType,
        state: { title: '设备型号' }
      },
      {
        breadcrumb: '添加设备型号',
        path: '/main/deviceType/create',
        Component: CreateDeviceType,
        state: { title: '添加设备型号' }
      },
      {
        breadcrumb: '设备型号详情',
        path: '/main/deviceType/detail',
        Component: DeviceTypeDetail,
        state: { title: '设备型号详情' }
      },
      {
        breadcrumb: '编辑设备型号',
        path: '/main/deviceType/edit',
        Component: DeviceTypeEdit,
        state: { title: '编辑设备型号' }
      },
      {
        breadcrumb: '公司列表',
        path: '/main/company',
        Component: Company,
        state: { title: '公司列表' }
      },
      {
        breadcrumb: '公司详情',
        path: '/main/company/detail',
        Component: CompanyDetail,
        state: { title: '公司详情' }
      },
      {
        breadcrumb: '编辑公司',
        path: '/main/company/edit',
        Component: CompanyEdit,
        state: { title: '编辑公司' }
      },
      {
        breadcrumb: '添加公司',
        path: '/main/company/create',
        Component: CompanyCreate,
        state: { title: '添加公司' }
      },
      {
        breadcrumb: '公司菜单',
        path: '/main/companyMenu',
        Component: CompanyMenu,
        state: { title: '公司菜单' }
      },
      {
        breadcrumb: '平台菜单',
        path: '/main/platformMenu',
        Component: PlatformMenu,
        state: { title: '平台菜单' }
      },
      {
        breadcrumb: '人员管理',
        path: '/main/personList',
        Component: User,
        state: { title: '人员管理' }
      },
      {
        breadcrumb: '角色管理',
        path: '/main/roleList',
        Component: Role,
        state: { title: '角色管理' }
      },
      {
        breadcrumb: '设置权限',
        path: '/main/roleList/setPermission',
        Component: SetRolePermission,
        state: { title: '设置权限' }
      },
      {
        path: '*',
        Component: NotFound,
      }
    ]
  },
])

export default router;